// MUI
import { styled } from "@mui/system";

import Typography from "../MaterialKit/MKTypography";

const LabelText = styled(Typography)(({ theme }) =>
  theme.unstable_sx({
    fontSize: "13px",
    [theme.breakpoints.up("lg")]: {
      fontSize: "14px",
    },
  })
);

export default LabelText;
